import * as ptbAjax from './ptbAjax'
import * as paths from './paths'

export const boardDefSetPayload = (swimlaneSetId) => ({ swimlanesetid: swimlaneSetId })

export class VapiClient {
  setAuthToken = (authToken) => {
    this.authToken = authToken
  }

  deleteComment = (taskId, commentId) =>
    ptbAjax.del(
      paths.deleteComment(taskId, commentId),
      this.authToken
    )

  addComment = (taskId, commentText) =>
    ptbAjax.post(
      paths.addComment(taskId),
      this.authToken,
      { commentText }
    )

  getComments = (taskId) =>
    ptbAjax.get(paths.getComments(taskId), this.authToken)

  getTaskLinks = (taskId) =>
    ptbAjax.get(paths.getTaskLinks(taskId), this.authToken)

  addTaskLink = (taskId, url, name) =>
    ptbAjax.post(paths.postTaskLink(taskId), this.authToken, { url, name })

  deleteTaskLink = (taskId, linkId) =>
    ptbAjax.del(paths.deleteTaskLink(taskId, linkId), this.authToken)

  getTaskChecklistItems = (taskId) =>
    ptbAjax.get(paths.getTaskChecklistItems(taskId), this.authToken)

  addTaskChecklistItem = (taskId, checklistItemName) =>
    ptbAjax.post(
      paths.addTaskChecklistItem(taskId),
      this.authToken,
      { name: checklistItemName }
    )

  deleteTaskChecklistItem = (taskId, checklistItemId) =>
    ptbAjax.del(paths.deleteTaskChecklistItem(taskId, checklistItemId), this.authToken)

  moveTaskChecklistItem = (taskId, checklistItemId, nextChecklistItemId) =>
    ptbAjax.put(
      paths.moveTaskChecklistItem(taskId, checklistItemId),
      this.authToken,
      { nextChecklistItemId }
    )

  updateTaskChecklistItem = (taskId, checklistItemId, name, checked) =>
    ptbAjax.put(
      paths.updateTaskChecklistItem(taskId, checklistItemId),
      this.authToken,
      { name, checked }
    )

  getProject = (projectId) =>
    ptbAjax.get(paths.getProject(projectId), this.authToken)

  getProjectMembers = (projectId) =>
    ptbAjax.get(paths.getProjectMembers(projectId), this.authToken)

  getTasks = (projectId) =>
    ptbAjax.get(paths.getTasks(projectId), this.authToken)

  putTaskPosition = (projectId, taskId, laneId, nextTaskId) =>
    ptbAjax.put(
      paths.putTaskPosition(projectId, taskId),
      this.authToken,
      { laneId, nextTaskId }
    )

  setTaskField = (projectId, taskId, fieldName, fieldValue) =>
    ptbAjax.put(
      paths.putTask(projectId, taskId),
      this.authToken,
      { [fieldName]: fieldValue }
    )

  getBoardDef = (projectId) =>
    ptbAjax.get(paths.getBoardDef(projectId), this.authToken)

  setBoardDef = (projectId, boardDefId) =>
    ptbAjax.post(
      paths.setBoardDef(projectId),
      this.authToken,
      { swimlanesetid: boardDefId }
    )

  getBoardDefs = () =>
    ptbAjax.get(paths.getBoardDefs(), this.authToken)

  postFeedback = (comment, like, userInfo) =>
    ptbAjax.post(
      paths.feedbackRoute(),
      this.authToken,
      {
        comment: comment,
        enterpriseId: userInfo.enterpriseId,
        enterpriseName: userInfo.enterpriseName,
        like: like,
        userEmail: userInfo.email,
        userName: `${userInfo.firstName} ${userInfo.lastName}`
      }
    )

  getUserInfo = () =>
    ptbAjax.get(paths.getUserInfo(), this.authToken)

  addNewTask = (projectId, name) =>
    ptbAjax.post(paths.addNewTask(projectId), this.authToken, { name })

  deleteTask = (projectId, taskId) =>
    ptbAjax.del(paths.deleteTask(projectId, taskId), this.authToken)
}



// WEBPACK FOOTER //
// ./src/ajax/vapiClient.js